import {
  Component,
  Output,
  EventEmitter,
  Input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService, UserType } from 'src/app/services/auth.service';
import { ROLE_LABELS } from 'src/app/services/user.service';
import { NotificationCenterService, AppNotification, NOTIF_KIND_ICONS } from 'src/app/services/notification-center.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LanguageSwitcherComponent } from 'src/app/core/components/language-switcher/language-switcher.component';
import { NetworkBadgeComponent } from 'src/app/core/offline/network-badge.component';

interface notifications {
  id: number;
  icon: string;
  color: string;
  title: string;
  time: string;
  subtitle: string;
}

interface inbox {
  id: number;
  bgcolor: string;
  imagePath: string;
  title: string;
  time: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  title: string;
  icon: string;
  link: string;
  new?: boolean;
}

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    LanguageSwitcherComponent,
    NetworkBadgeComponent,
    TranslateModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleShoppingCartNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  isCollapse: boolean = false; // Initially hidden

  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }


  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();

  roleLabels = ROLE_LABELS;
  appNotifications: AppNotification[] = [];
  unreadCount = 0;
  notifIcons = NOTIF_KIND_ICONS;

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    public auth: AuthService,
    private notifCenter: NotificationCenterService,
  ) {
    translate.setDefaultLang('fr');

    // Le centre de notifications expose un BehaviorSubject ; on s'y abonne pour
    // rafraîchir le badge dès qu'une notification arrive ou est lue.
    this.notifCenter.items$.subscribe((items) => {
      this.appNotifications = items.slice(0, 6);
    });
    this.notifCenter.unreadCount$.subscribe((c) => (this.unreadCount = c));
  }

  /** Initiales utilisées dans l'avatar quand aucune image n'est disponible. */
  get initials(): string {
    const u = this.auth.currentUser;
    if (!u) return '??';
    return ((u.firstName?.[0] || '') + (u.lastName?.[0] || '')).toUpperCase();
  }

  get currentRoleLabel(): string {
    return this.roleLabels[this.auth.currentRole()] || this.auth.currentRole();
  }

  get displayName(): string {
    const u = this.auth.currentUser;
    if (!u) return 'Utilisateur';
    return `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email;
  }

  logout(): void {
    this.auth.logout();
  }

  options = this.settings.getOptions();

  openDialog() {
    this.dialog.open(AppSearchDialogComponent);
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  notifications: notifications[] = [
    {
      id: 1,
      icon: 'solar:widget-3-line-duotone',
      color: 'primary',
      time: '9:30 AM',
      title: 'Launch Admin',
      subtitle: 'Just see the my new admin!',
    },
    {
      id: 2,
      icon: 'solar:calendar-line-duotone',
      color: 'secondary',
      time: '9:15 AM',
      title: 'Event today',
      subtitle: 'Just a reminder that you have event',
    },
    {
      id: 3,
      icon: 'solar:settings-line-duotone',
      color: 'warning',
      time: '4:36 AM',
      title: 'Settings',
      subtitle: 'You can customize this template',
    },
    {
      id: 4,
      icon: 'solar:widget-4-line-duotone',
      color: 'success',
      time: '7:30 AM',
      title: 'Launch Templates',
      subtitle: 'Just see the my new admin!',
    },
    {
      id: 5,
      icon: 'solar:calendar-line-duotone',
      color: 'error',
      time: '7:03 AM',
      title: 'Event tomorrow',
      subtitle: 'Just a reminder that you have event',
    },
    {
      id: 6,
      icon: 'solar:settings-line-duotone',
      color: 'primary',
      time: '8:30 AM',
      title: 'Launch Admin',
      subtitle: 'Just see the my new admin!',
    },
  ];

  inbox: inbox[] = [
    {
      id: 1,
      bgcolor: 'bg-error',
      imagePath: 'assets/images/profile/user-6.webp',
      time: 'just now',
      title: 'Michell Flintoff',
      subtitle: 'You: Yesterdy was great...',
    },
    {
      id: 2,
      bgcolor: 'bg-primary',
      imagePath: 'assets/images/profile/user-2.webp',
      time: '5 mins ago',
      title: 'Bianca Anderson',
      subtitle: 'Nice looking dress you...',
    },
    {
      id: 3,
      bgcolor: 'bg-success',
      imagePath: 'assets/images/profile/user-3.webp',
      time: '10 mins ago',
      title: 'Andrew Johnson',
      subtitle: 'Sent a photo',
    },
    {
      id: 4,
      bgcolor: 'bg-warning',
      imagePath: 'assets/images/profile/user-4.webp',
      time: 'days ago',
      title: 'Marry Strokes',
      subtitle: 'If I don’t like something',
    },
    {
      id: 5,
      bgcolor: 'bg-success',
      imagePath: 'assets/images/profile/user-5.webp',
      time: 'year ago',
      title: 'Josh Anderson',
      subtitle: '$230 deducted from account',
    },
  ];

  /** Menu profil contextualisé selon le rôle courant. */
  get profiledd(): profiledd[] {
    const role: UserType = this.auth.currentRole();
    // Les titres sont des CLÉS de traduction — le template applique
    // {{ profile.title | translate }} pour les rendre dans la langue active.
    const items: profiledd[] = [
      {
        id: 1,
        icon: 'solar:user-circle-line-duotone',
        title: 'nav.profile',
        link: '/dinki/profil',
      },
      {
        id: 2,
        icon: 'solar:bell-line-duotone',
        title: 'nav.notifications',
        link: '/dinki/notifications',
      },
    ];

    if (role === 'ADMIN' || role === 'BUSINESS') {
      items.push(
        {
          id: 10,
          icon: 'solar:home-smile-line-duotone',
          title: 'nav.dashboard',
          link: '/dinki/dashboard',
        },
        {
          id: 11,
          icon: 'solar:shop-line-duotone',
          title: 'nav.atelier',
          link: '/dinki/atelier',
        },
        {
          id: 12,
          icon: 'solar:crown-line-duotone',
          title: 'nav.abonnement',
          link: '/dinki/abonnement',
        },
        {
          id: 13,
          icon: 'solar:settings-line-duotone',
          title: 'nav.parametres',
          link: '/dinki/parametres',
        },
      );
    }

    if (role === 'ADMIN') {
      items.push({
        id: 20,
        icon: 'solar:shield-user-line-duotone',
        title: 'nav.section_administration',
        link: '/dinki/admin/overview',
      });
    }

    if (role === 'CUSTOMER') {
      items.push(
        {
          id: 30,
          icon: 'solar:ruler-line-duotone',
          title: 'nav.my_measurements',
          link: '/dinki/mes-mesures',
        },
        {
          id: 31,
          icon: 'solar:bag-3-line-duotone',
          title: 'nav.my_orders',
          link: '/dinki/mes-commandes',
        },
      );
    }

    if (role === 'PARTNER') {
      items.push(
        {
          id: 40,
          icon: 'solar:hand-shake-line-duotone',
          title: 'nav.partner',
          link: '/dinki/partenariat',
        },
        {
          id: 41,
          icon: 'solar:wallet-money-line-duotone',
          title: 'nav.commissions',
          link: '/dinki/partenariat/commissions',
        },
      );
    }

    return items;
  }
}

@Component({
  selector: 'search-dialog',
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    MatDividerModule,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);
}
